import React from "react";
import "./index.css";
export function ProtocolTable({ data }) {
  const formatReferrals = (referrals) => {
    if (typeof referrals === "string") {
      return referrals === "None" ? "No referrals needed" : referrals;
    }
    return Array.isArray(referrals)
      ? referrals.join(", ")
      : "No referrals needed";
  };
  
  return (
    <div className="protocol-container">
      <div className="protocol-header">
        <h3 className="protocol-title">
          HYPERTENSION MANAGEMENT PROTOCOL AI RECOMMENDED PROTOCOL (FOR DR
          REVIEW & ADVISE)
        </h3>
      </div>
      <div className="protocol-table">
        <div className="protocol-row">
          <div className="protocol-category">LAB INVESTIGATIONS</div>
          <div className="protocol-details">
            {data.lab_investigations && data.lab_investigations.length > 0
              ? data.lab_investigations.join(", ")
              : "No specific lab investigations required"}
          </div>
        </div>

        <div className="protocol-row">
          <div className="protocol-category">DIAGNOSTICS AND IMAGING</div>
          <div className="protocol-details">
            {data.diagnostics_and_imaging &&
            data.diagnostics_and_imaging.length > 0
              ? data.diagnostics_and_imaging.join(", ")
              : "No specific diagnostics required"}
          </div>
        </div>

        <div className="protocol-row">
          <div className="protocol-category">MEDICATIONS</div>
          <div className="protocol-details">
            {data.medications || "No medications specified"}
          </div>
        </div>

        <div className="protocol-row">
          <div className="protocol-category">REFERRALS</div>
          <div className="protocol-details">
            {formatReferrals(data.referrals)}
          </div>
        </div>

        <div className="protocol-row">
          <div className="protocol-category">FOLLOW-UP SCHEDULE</div>
          <div className="protocol-details">
            {data.follow_up_schedule || "Follow-up as needed"}
          </div>
        </div>

        <div className="protocol-row">
          <div className="protocol-category">TREATMENT GOALS</div>
          <div className="protocol-details">
            {data.treatment_goals &&
            Object.keys(data.treatment_goals).length > 0
              ? Object.entries(data.treatment_goals).map(
                  ([key, value], index) => (
                    <div key={index} className="aicvd-radio-options">
                      <strong>{key.replace(/_/g, " ").toUpperCase()}: </strong>
                      {value}
                    </div>
                  )
                )
              : "No specific treatment goals defined"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProtocolTable;
